// extracted by mini-css-extract-plugin
module.exports = {"publicUserDescription":"Home_publicUserDescription__vRQvi"};